import CancelRegister from './CancelRegister';
export default CancelRegister;
